import classNames from 'classnames'
import React, { useState } from 'react'
import { UnifiedCard } from '../../../integrations/allkort/graphql/interface/Customer'
import { ReplaceCircleIcon } from '../../svgs/ExpressonSVGs'
import OrderNewCard from '../../views/Cards/OrderNewCard'
import RightsWrapper from '../RightsWrapper'

type CardOrderReplacementProps = {
    isCreditCard?: boolean
    isCompany: boolean
    hasSmartCard?: boolean
    hasCreditCard?: boolean
    card: UnifiedCard
    onSuccess?: () => void
}

const CardOrderReplacement: React.FC<CardOrderReplacementProps> = ({ isCreditCard, isCompany, hasCreditCard, hasSmartCard, card, onSuccess }) => {
    const [isOrderNewCardOpen, setIsOrderNewCardOpen] = useState(false)

    const handleClick = () => {
        setIsOrderNewCardOpen(true)
    }

    return (
        <div className="card-order-replacement">
            <RightsWrapper
                disableButtonText={'Ersätt kort'}
                disableButtonClasses="disable-fill-color body-text"
                disableButtonIcon={<ReplaceCircleIcon width={24} height={24} />}
            >
                <button
                    type="button"
                    className={classNames(
                        'card-order-replacement-button',
                        'button-edit',
                        'body-text',
                        { 'invert': !isCreditCard }
                    )}
                    onClick={handleClick}
                >
                    <ReplaceCircleIcon width={24} height={24} />
                    Ersätt kort
                </button>
            </RightsWrapper>


            <OrderNewCard
                orderReplacement={true}
                isOpen={isOrderNewCardOpen}
                isCompany={isCompany}
                hasK={hasCreditCard}
                hasP={hasSmartCard}
                card={card}
                onClose={() => setIsOrderNewCardOpen(false)}
                onSuccess={onSuccess}
            />
        </div>
    )
}

export default CardOrderReplacement;